// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInfoBanner-cls1_sIh","cls2":"CiterightInfoBanner-cls2_Z2q CiterightInfoBanner-cls1_sIh"};